import type { Contexts, ErrorLogger } from '@/modules/book-visit/domain/errors/ErrorLogger';
import { errorTracker } from '@/modules/error-logger/public/api';

export class GlobalErrorLogger implements ErrorLogger {
  logExceptionWithContext(error: Error, contexts: Contexts): void {
    errorTracker().logError(error, { contexts, tags: { module: 'book-visit' } });
  }
}
